"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IFrame = exports.VideoWrapper = exports.CtaContainer = exports.Content = exports.Image = exports.ImageWrapper = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mediaGenerator = _interopRequireDefault(require("@berlitz/max-utils/lib/mediaGenerator"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var shimmerBackground = (0, _styledComponents.keyframes)(["0%{background-position:-800px 0}100%{background-position:800px 0}"]);
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Cardstyle__Wrapper",
  componentId: "sc-1nom7rt-0"
})(["", " @media (min-width:", "){flex-direction:", ";}", ""], function (_ref) {
  var card = _ref.theme.card,
    flat = _ref.flat;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;background:", ";border-radius:", ";box-shadow:", ";overflow:hidden;position:relative;height:100%;a &{transition:", ";@media (min-width:", "){&:hover,&:focus{", "}}}"], card.backgroundColor, card.borderRadius, !flat && card.boxShadow, card.transition, function (_ref2) {
    var theme = _ref2.theme;
    return theme.breakpoints.md;
  }, !flat && (0, _styledComponents.css)(["box-shadow:", ";transform:", ";"], card.boxShadowHover, card.activeTransform));
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.md;
}, function (_ref4) {
  var row = _ref4.row;
  return row ? 'row' : 'column';
}, function (_ref5) {
  var row = _ref5.row;
  return row && (0, _styledComponents.css)(["@media (max-width:", "){flex-direction:column;}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.breakpoints.lg;
  });
});
exports.Wrapper = Wrapper;
var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Cardstyle__ImageWrapper",
  componentId: "sc-1nom7rt-1"
})(["border-radius:", ";overflow:hidden;position:relative;width:100%;@supports (display:-ms-grid){min-height:242px;}", ";background:", ";display:inline-block;position:relative;", ""], function (_ref7) {
  var flat = _ref7.flat,
    theme = _ref7.theme;
  return flat && theme.button.borderRadius;
}, function (_ref8) {
  var row = _ref8.row,
    card = _ref8.theme.card,
    imageSize = _ref8.imageSize;
  return row ? (0, _styledComponents.css)(["flex:1 1 0;min-height:", ";"], imageSize === 'lg' ? card.rowImageHeightLarge : card.rowImageHeightDefault) : (0, _styledComponents.css)(["padding-bottom:", ";height:0;"], card.imageRatio);
}, function (_ref9) {
  var theme = _ref9.theme,
    containImage = _ref9.containImage;
  return containImage ? 'transparent' : theme.palette.gray10;
}, function (_ref10) {
  var isImageLoading = _ref10.isImageLoading,
    theme = _ref10.theme;
  return isImageLoading && (0, _styledComponents.css)(["background-repeat:no-repeat;animation-fill-mode:forwards;animation:", " 5s cubic-bezier(0.68,-0.55,0.27,1.55) infinite;animation-timing-function:linear;background:linear-gradient( 90deg,", " 20%,", " 50%,", " 80% );"], shimmerBackground, theme.palette.gray10, theme.palette.white, theme.palette.gray10);
});
exports.ImageWrapper = ImageWrapper;
var Image = _styledComponents.default.img.withConfig({
  displayName: "Cardstyle__Image",
  componentId: "sc-1nom7rt-2"
})(["position:absolute;width:100%;left:0;", " ", " @supports (object-fit:cover){top:0;height:100%;object-fit:", ";}"], function (_ref11) {
  var containImage = _ref11.containImage;
  return containImage && (0, _styledComponents.css)(["padding:", ";padding-bottom:0;"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.space.lg;
  });
}, function (_ref13) {
  var borderColor = _ref13.borderColor,
    theme = _ref13.theme;
  return borderColor && (0, _styledComponents.css)(["border-bottom:", " solid ", ";"], theme.space.xs, theme.colors[borderColor]);
}, function (_ref14) {
  var containImage = _ref14.containImage;
  return containImage ? 'contain' : 'cover';
});
exports.Image = Image;
var Content = _styledComponents.default.div.withConfig({
  displayName: "Cardstyle__Content",
  componentId: "sc-1nom7rt-3"
})(["padding:", ";flex-grow:1;*:last-child{margin-bottom:0;}", " ", ""], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.lg;
}, function (_ref16) {
  var theme = _ref16.theme,
    row = _ref16.row;
  return (0, _mediaGenerator.default)(theme, row, 'flex: 1 1 0;');
}, function (_ref17) {
  var cta = _ref17.cta;
  return cta && (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:space-between;"]);
});
exports.Content = Content;
var CtaContainer = _styledComponents.default.div.withConfig({
  displayName: "Cardstyle__CtaContainer",
  componentId: "sc-1nom7rt-4"
})(["display:flex;padding-top:", ";margin-top:auto;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.lg;
});
exports.CtaContainer = CtaContainer;
var VideoWrapper = _styledComponents.default.div.withConfig({
  displayName: "Cardstyle__VideoWrapper",
  componentId: "sc-1nom7rt-5"
})(["display:block;position:relative;background:", ";padding-bottom:", ";", " ", ""], function (_ref19) {
  var theme = _ref19.theme;
  return theme.palette.gray10;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.card.imageRatio;
}, function (_ref21) {
  var isImageLoading = _ref21.isImageLoading,
    theme = _ref21.theme;
  return isImageLoading && (0, _styledComponents.css)(["background-repeat:no-repeat;animation-fill-mode:forwards;animation:", " 5s cubic-bezier(0.68,-0.55,0.27,1.55) infinite;animation-timing-function:linear;background:", ";background:linear-gradient( 90deg,", " 20%,", " 50%,", " 80% );"], shimmerBackground, theme.palette.gray10, theme.palette.gray10, theme.palette.white, theme.palette.gray10);
}, function (_ref22) {
  var row = _ref22.row;
  return row && (0, _styledComponents.css)(["display:flex;padding:0;"]);
});
exports.VideoWrapper = VideoWrapper;
var IFrame = _styledComponents.default.iframe.withConfig({
  displayName: "Cardstyle__IFrame",
  componentId: "sc-1nom7rt-6"
})(["position:absolute;top:0;left:0;width:100%;height:100%;", ""], function (_ref23) {
  var row = _ref23.row;
  return row && (0, _styledComponents.css)(["position:relative;"]);
});
exports.IFrame = IFrame;